import {API_PATH} from "../../constants";
import {axiosRequest} from "../api";


export const NotificationService = {
  getNotificationToken(params: any){ return axiosRequest('GET', API_PATH.NOTIFICATION.TOKEN(params)) },
  pushMessage(data: any){ return axiosRequest('POST', API_PATH.NOTIFICATION.PUSH_MESSAGE, data) },
}